import React from 'react';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const BankTransferFinalStep = () => {
    const { id } = useExtra();
    const { bankTransferTitle2, bankTransferButton, topUpBankTransferFinalStep } = usePageMessages();
    const getText = (text) => {
        return <DangerouslyHtml dangerouslyHtml={text} />;
    };

    return (
        <BaseLayout showChat={false}>
            <InfoPage
                iconName="clock-80"
                iconColor="primary"
                headerText={bankTransferTitle2}
                secondaryText={getText(topUpBankTransferFinalStep)}
                primaryButtonCaption={bankTransferButton}
                primaryButtonType="link"
                primaryButtonLink={`/auth/ga/pocket/${id}`}
            />
        </BaseLayout>
    );
};

export default BankTransferFinalStep;
